/**
 * Route definition for /
 * Renders the About page as the default landing page.
 *
 * @module routes/index
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import AboutContainer from '@/containers/About'

export const Route = createFileRoute('/$locale/')({
  component: About,
})

/**
 * About page component.
 * Renders the About container to display information about the marketplace.
 *
 * @returns {React.ReactElement}
 */
function About() {
  return (
    <>
      <AboutContainer />
    </>
  )
}
